import {
  Component,
  DestroyRef,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { UserRolesAndPermissionsService } from '@core/services/user-roles-and-permissions.service';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { AssetRouteName } from '@pages/assets-page/assets-page.module';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';

@Component({
  imports: [DvTabsComponent, RouterOutlet],
  selector: 'app-assets-tabs',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './assets-tabs.component.html',
})
export class AssetsTabsComponent implements OnInit {
  private translate = inject(TranslateService);
  private router = inject(Router);
  private permissionsService = inject(UserRolesAndPermissionsService);

  tabLinks: DvTabLink[] = [];
  private destroyRef = inject(DestroyRef);

  constructor() {
    this.permissionsService
      .hasPermissions([RolesAndPermissions.AssetShowInMap])
      .pipe(take(1))
      .subscribe(canSeeMap => {
        this.tabLinks = [
          {
            label: this.translate.instant('Asset.Information'),
            link: AssetRouteName.Information,
          },
          {
            label: this.translate.instant('Asset.PictureAndDocument'),
            link: AssetRouteName.PictureDocument,
          },
          {
            label: this.translate.instant('Asset.Log'),
            link: AssetRouteName.Log,
            hide: !canSeeMap,
          },
          {
            label: this.translate.instant('Asset.AdditionalProperties'),
            link: AssetRouteName.Properties,
          },
        ].map(tab => ({ ...tab, id: tab.link }));
      });
  }

  ngOnInit(): void {
    this.toggleTabLinks();
    this.listenToUrlChanges();
  }

  private listenToUrlChanges(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.toggleTabLinks();
        }
      });
  }

  private toggleTabLinks(): void {
    this.tabLinks = this.tabLinks.map(tablink => ({
      ...tablink,
      disable:
        this.router.url.includes('/new/information') &&
        tablink.link !== 'information'
          ? true
          : false,
    }));
  }
}
